import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@projectobelisk/uikit/components/feedback/empty";
import { createFileRoute } from "@tanstack/react-router";
import { Activity } from "lucide-react";

export const Route = createFileRoute("/_app/call-center/monitoring")({
  staticData: { title: "Monitoring", breadcrumb: "Monitoring" },
  component: Monitoring,
});

function Monitoring() {
  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Activity />
        </EmptyMedia>
        <EmptyTitle>No live calls to monitor</EmptyTitle>
        <EmptyDescription>
          Active calls will appear here in real time as they happen.
        </EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
}
